module.exports = __webpack_public_path__ + "static/media/check.5fc31a61.svg";